import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  REMOVE_MEMBER_FROM_SPACE,
  RESET_SPACE_MEMBERS_PAGINATION_STATE,
  SET_EDIT_SPACE_MEMBER,
  SET_FILTER_SPACE_MEMBER,
  SET_NEW_SPACE_MEMBER,
  SET_SPACE_MEMBERS_SORTING_STATE
} from './actionTypes'

export const setSortingColumn = (sortBy?: string, sortOrder?: string): AppThunk => {
  return dispatch => {
    dispatch(
      createAction(SET_SPACE_MEMBERS_SORTING_STATE, {
        sortingColumn: sortBy && sortOrder ? { [sortBy]: { direction: sortOrder.toLowerCase() } } : {}
      })
    )
  }
}

export const setFilter = (filter: unknown): AppThunk => {
  return dispatch => dispatch(createAction(SET_FILTER_SPACE_MEMBER, { filter }))
}

export const setEditUser = (isEditingUser: boolean): AppThunk => {
  return dispatch => dispatch(createAction(SET_EDIT_SPACE_MEMBER, { isEditingUser }))
}

export const setNewUser = (isNewUser: boolean): AppThunk => {
  return dispatch => dispatch(createAction(SET_NEW_SPACE_MEMBER, { isNewUser }))
}

export const resetPaginationState = (): AppThunk => {
  return dispatch => dispatch(createAction(RESET_SPACE_MEMBERS_PAGINATION_STATE))
}

export const removeFromSpace = (userId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/users/${userId}`,
        REMOVE_MEMBER_FROM_SPACE,
        { method: 'DELETE' },
        { args: { organizationId: ':organizationId', spaceId: ':spaceId', userId } }
      )
    )
  }
}
